import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  management:false,
  reporting:false,
  loyalty:false,
  moderation:false,
  cms:false,
};

const collapseSlice = createSlice({
  name: 'collapseValues',
  initialState,
  reducers: {
    open(state,action) {
      if(action.payload.management===true || action.payload.management===false)
        state.management = action.payload.management;
      if(action.payload.reporting===true || action.payload.reporting===false)
        state.reporting = action.payload.reporting;
      if(action.payload.loyalty===true || action.payload.loyalty===false)
        state.loyalty = action.payload.loyalty;
      if(action.payload.moderation===true || action.payload.moderation===false)
        state.moderation = action.payload.moderation;
      if(action.payload.cms===true || action.payload.cms===false)
        state.cms = action.payload.cms;
    },
  },
});

export const { open } = collapseSlice.actions;
export default collapseSlice.reducer;